import React, { useEffect } from 'react';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { QueryInterop as Query } from '@confluence/apollo-relay-interop/entry-points/QueryInterop.ts';

import ContentViewedEventQuery from './__generated__/ContentViewedEventQuery.graphql.ts';

type ContentViewedEventProps = {
	contentId: string;
};

let lastContentId: string;

export const ContentViewedEvent = ({ contentId }: ContentViewedEventProps): React.JSX.Element => {
	useEffect(() => {
		lastContentId = contentId;
	}, [contentId]);

	return (
		<Query
			query={ContentViewedEventQuery}
			variables={{ contentId }}
			fetchPolicy="network-only"
			skip={lastContentId === contentId}
		>
			{() => null}
		</Query>
	);
};
